// Process polyfill for browser environment
// This provides a minimal process object that matches what is-electron.ts expects
// This avoids the vite-plugin-node-polyfills shim import issue

if (typeof globalThis !== 'undefined' && typeof globalThis.process === 'undefined') {
  globalThis.process = {
    env: typeof import.meta !== 'undefined' && import.meta.env ? {
      EWX_CHECK_UA: import.meta.env.VITE_EWX_CHECK_UA,
    } : {},
    versions: {} as any,
    type: undefined,
    platform: undefined,
    argv: [],
    execPath: '',
    defaultApp: false,
  } as any;
}

